import { render, staticRenderFns } from "./upload-file.vue?vue&type=template&id=36bf3d32&scoped=true&"
import script from "./upload-file.vue?vue&type=script&lang=js&"
export * from "./upload-file.vue?vue&type=script&lang=js&"
import style0 from "./upload-file.vue?vue&type=style&index=0&id=36bf3d32&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bf3d32",
  null
  
)

export default component.exports